import React, { useState } from 'react';
import { AdPositionRowsContainer } from 'shared/containers/AdPositionRows';
import { UniqueView } from 'shared/components/UniqueView';
import { AdPositionBlocksContainer } from 'shared/containers/AdPositionBlocks';
import { RateNumberInputContainer } from '../RateNumberInput';
import { useDeviceType } from '@cian/ui-kit';

const RATE_VALUES = [10, 20, 30, 50];
const RATE_LABEL = 'Ставка за уникальный просмотр';

export const UniqueViewContainer: React.FC = () => {
  const [index, setIndex] = useState(0);

  const device = useDeviceType();

  const handleIndex = (value: number) => {
    setIndex(value);
  };

  return (
    <UniqueView
      device={device}
      adPositionRows={<AdPositionRowsContainer index={index} />}
      adPositionBlocks={<AdPositionBlocksContainer index={index} />}
      numberInput={
        <RateNumberInputContainer
          values={RATE_VALUES}
          index={index}
          onIndexChange={handleIndex}
          label={RATE_LABEL}
          showSetMaxButton
        />
      }
    />
  );
};
